<form #customerForm="ngForm">
  <div class="flex flex-col md:flex-row" mat-dialog-title>
    <div class="w-full">
      <h1 class="mt-2">Add Customer</h1>
    </div>
    <div>
      <mat-slide-toggle
        color="warn"
        [checked]="true"
        name="Hires Disabled"
        [(ngModel)]="model.hires_disabled"
      >
        Disable Hires
      </mat-slide-toggle>
    </div>
  </div>
  <mat-dialog-content>
    <div class="flex flex-col md:flex-row md:gap-x-4">
      <div class="flex flex-col gap-y-8 md:basis-1/2 basis-full flex-skrink">
        <mat-radio-group
          [(ngModel)]="model.business"
          class="flex flex-row gap-x-4"
          name="Business"
          (change)="typeChanged($event)"
        >
          <mat-radio-button [value]="0">Individual</mat-radio-button>
          <mat-radio-button [value]="1">Organisation</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="model.business === 0" class="flex flex-col">
          <h3>Personal Details</h3>
          <div class="flex flex-col md:flex-row md:gap-x-4">
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>First Name</mat-label>
              <input
                matInput
                placeholder="First Name"
                name="First name"
                [(ngModel)]="model.first_name"
                autocomplete="new-customer-first-name"
                required
              />
            </mat-form-field>
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                placeholder="Last Name"
                name="Last name"
                [(ngModel)]="model.last_name"
                autocomplete="new-customer-last-name"
                required
              />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="model.business === 1">
          <h3>Organisation Details</h3>
          <div class="flex flex-row">
            <mat-form-field class="w-full">
              <mat-label>Name</mat-label>
              <input
                matInput
                placeholder="Name"
                name="name"
                [(ngModel)]="model.business_name"
                autocomplete="new-customer-business-name"
                required
              />
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-col gap-y-4">
          <h3>Contact Details</h3>
          <div class="flex flex-col md:flex-row md:gap-x-3">
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>Telephone</mat-label>
              <input
                type="tel"
                matInput
                placeholder="Telephone"
                name="Telephone"
                autocomplete="new-customer-phone-number"
                [(ngModel)]="model.telephone"
                required
              />
            </mat-form-field>
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>Email</mat-label>
              <input
                type="email"
                matInput
                placeholder="Email"
                name="Email"
                autocomplete="new-customer-email"
                [(ngModel)]="model.email"
              />
            </mat-form-field>
          </div>
          <div class="flex flex-col md:flex-row md:gap-x-3">
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>Telephone 2</mat-label>
              <input
                matInput
                type="tel"
                placeholder="Telephone 2"
                name="Telephone 2"
                autocomplete="new-customer-alt-phone"
                [(ngModel)]="model.alt_telephone"
              />
            </mat-form-field>
            <mat-form-field class="w-full md:w-1/2">
              <mat-label>Telephone 3</mat-label>
              <input
                type="tel"
                matInput
                placeholder="Telephone 3"
                name="Telephone 3"
                autocomplete="new-customer-alt-phone-2"
                [(ngModel)]="model.mobile"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="flex flex-col basis-1/2 flex-grow-0 flex-shrink gap-y-3">
        <h3>Address</h3>
        @if (selectAddress) {
        <app-address-selector
          (addressFound)="loadAddress($event)"
        ></app-address-selector>
        <button
          mat-flat-button
          (click)="selectAddress = false"
          class="self-center"
        >
          Enter manually
        </button>
        } @else {
        <button
          mat-flat-button
          (click)="selectAddress = true"
          class="self-center"
        >
          Search
        </button>
        <mat-form-field>
          <mat-label>Address line 1</mat-label>
          <input
            matInput
            placeholder="Address line 1"
            name="Address line 1"
            [(ngModel)]="model.address_1"
            autocomplete="new-customer-address"
            required
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Town/City</mat-label>
          <input
            matInput
            placeholder="Town/City"
            name="Town/City"
            [(ngModel)]="model.city"
            autocomplete="new-customer-town"
            required
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Post Code</mat-label>
          <input
            matInput
            placeholder="Post Code"
            name="Post code"
            [(ngModel)]="model.post_code"
            autocomplete="new-customer-post-code"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>County</mat-label>
          <input
            matInput
            placeholder="County"
            name="County"
            [(ngModel)]="model.county"
            autocomplete="new-customer-post-code"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Country</mat-label>
          <input
            matInput
            placeholder="Country"
            name="Country"
            [(ngModel)]="model.country"
            autocomplete="new-customer-country"
          />
        </mat-form-field>
        }
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()">
      Add Customer
    </button>
  </div>
</form>
